// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"EmailTagInput-primaryButton-3GO-5v","invalidEmail":"EmailTagInput-invalidEmail-Rt7r8b"};